<template>
  <div id="team">
    <h2>{{ lang.sentences.meetOurTeam }}</h2>
    <TeamPanel
      v-for="(teamMember, x) in lang.teamPanels"
      :key="x"
      :name="teamMember.name"
      :title="teamMember.title"
      :linkedin="teamMember.linkedin"
      :bio="teamMember.bio"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TeamPanel from "./TeamPanel"

export default {
  name: "PageSlideTeam",
  components: { TeamPanel },
  computed: {
    ...mapGetters("languages", ["lang"])
  }
};
</script>

<style lang="scss" scoped>
#team {
  position: relative;
  width: 100%;
  min-height: 100%;
  min-height: $page-slide-min-height;
  overflow: hidden;
  object-fit: fill;
  background-color: $background-color-clear-1;
  padding-top: $menubar-height + $page-padding-top;
  text-align: center;
  h2 {
    color: $color-secondary-2;
    @extend #{$page-title-font-size};
    margin-bottom: $page-title-margin-bottom;
  }
}
</style>
